import { Component, OnInit, Input } from '@angular/core';
import { SharedService } from '../shared.service';


@Component( {
  selector: 'course-hot',
  templateUrl: './course-hot.component.html',
  styleUrls: [ './course-hot.component.scss' ]
} )
export class CourseHotComponent implements OnInit {
  couInfoData: any = [];
  coursetitle: any = "热门课程"; //课程标题

  constructor(
    private _service: SharedService
  ) { }

  ngOnInit() {
    this._service.getHotCourse().then( data => {
      if ( data[ 'data' ] && data[ 'data' ].length > 0 ) {
        this.couInfoData = data[ 'data' ].slice( 0, 3 );
      }
    } )
  }

}



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/shared/course-hot/course-hot.component.ts